export default __webpack_public_path__ + "static/media/Minuta.72362a78.svg";